import createReactClass from 'create-react-class';

//dangerouslySetInnerHTML seems to disables links. If you need to use links in your HTML content, please use html-new.jsx component instead.
export default function (dependencies) {
  const HTML = createReactClass({
    render() {
      var field = this.props.field;
      var apiStatus = field.state.api;
      var InputField = dependencies.InputField;
      return (
        <div
          className="lz-input-wrapper"
          dangerouslySetInnerHTML={{ __html: field.state.value }}
        ></div>
      );
    },
  });

  return {
    html: HTML,
    config: {
      ignored: true,
    },
  };
}
